import { render } from "./ButtonSubmit.vue?vue&type=template&id=48ed0cdc&ts=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=ts"
export * from "./ButtonSubmit.vue?vue&type=script&lang=ts"

import "./ButtonSubmit.vue?vue&type=style&index=0&id=48ed0cdc&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__